import { Component, OnInit } from '@angular/core';

import { AuthService } from './auth.service'
import { Session } from './session.model'

@Component({
  selector: 'app-active-sessions',
  templateUrl: './active-sessions.component.html',
  styleUrls: ['./active-sessions.component.scss']
})
export class ActiveSessionsComponent implements OnInit {

  constructor(private authService: AuthService) { }

  sessions: Session[] = [];

  ngOnInit() {
    this.authService.getSessions().subscribe(
      (sessions) => this.sessions = sessions
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/active-sessions.component.ts